import { render } from "./Stowing.vue?vue&type=template&id=55098388"
import script from "./Stowing.vue?vue&type=script&lang=js"
export * from "./Stowing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__